import React from 'react';
import ReactPaginate from 'react-paginate';
import { useRouter } from 'next/router';

import Block from 'components/Block';
import { PAGE_SIZES } from 'consts';
import useWindowSize from 'hooks/useWindowSize';
import ChevronLeftIcon from 'icons/chevron-left.svg';
import ChevronRightIcon from 'icons/chevron-right.svg';
import styles from './Pagination.module.css';

export interface PaginationProps {
  data: { count: number };
  pageSize: number;
  setPageSize: (pageSize: number) => void;
  paginationLength?: number;
}

const Pagination: React.FCWithChildren<PaginationProps> = ({ data, pageSize, setPageSize }) => {
  const router = useRouter();
  const { query, pathname } = router;
  const pageString = typeof query.page === 'string' && /\d/.test(query.page) ? query.page : '1';
  const page = Number(pageString);

  const { breakpoints } = useWindowSize();
  const isMobile = breakpoints['phone-down'];

  const { count } = data;
  const pageCount = Math.ceil(count / pageSize);

  const getHref = (page: number) => ({
    pathname,
    query: {
      ...query,
      page,
    },
  });

  if (pageCount <= 1) {
    return null;
  }

  return (
    <Block className={styles.root}>
      <div className={styles.sizeSelection}>
        <span>Items per page</span>
        {PAGE_SIZES.map(s => (
          <a
            role="button"
            onClick={() => setPageSize(s)}
            key={s}
            className={pageSize === s ? styles.currentSize : undefined}
          >
            {s}
          </a>
        ))}
      </div>
      <div>
        <ReactPaginate
          activeLinkClassName={styles.active}
          breakClassName={styles.linkItem}
          pageLinkClassName={styles.linkItem}
          containerClassName={styles.pagination}
          // Index
          initialPage={page - 1}
          breakLabel="..."
          nextLabel={
            <div className={styles.linkItem}>
              <ChevronRightIcon />
            </div>
          }
          previousLabel={
            <div className={styles.linkItem}>
              <ChevronLeftIcon />
            </div>
          }
          onPageChange={({ selected }) => {
            const pageNum = selected + 1;
            if (pageNum !== page) {
              router.push(getHref(pageNum));
            }
          }}
          pageRangeDisplayed={2}
          marginPagesDisplayed={isMobile ? 1 : 2}
          pageCount={pageCount}
        />
      </div>
      <div className={styles.right} />
    </Block>
  );
};

export default Pagination;
